/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  InvalidateQueryFilters,
  QueryClient,
  useQuery,
  UseQueryResult,
  useSuspenseQuery,
  UseSuspenseQueryResult,
} from "@tanstack/react-query";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  GetNetworkIngressRequest,
  GetNetworkIngressSecurity,
} from "../models/operations/getnetworkingress.js";
import { useGramContext } from "./_context.js";
import {
  QueryHookOptions,
  SuspenseQueryHookOptions,
  TupleToPrefixes,
} from "./_types.js";
import {
  buildNetworkIngressQuery,
  NetworkIngressQueryData,
  prefetchNetworkIngress,
  queryKeyNetworkIngress,
} from "./networkIngress.core.js";
export {
  buildNetworkIngressQuery,
  type NetworkIngressQueryData,
  prefetchNetworkIngress,
  queryKeyNetworkIngress,
};

export type NetworkIngressQueryError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * getIngress networkIngress
 *
 * @remarks
 * Get the active network ingress for the current organization, when configured.
 */
export function useNetworkIngress(
  request?: GetNetworkIngressRequest | undefined,
  security?: GetNetworkIngressSecurity | undefined,
  options?: QueryHookOptions<NetworkIngressQueryData, NetworkIngressQueryError>,
): UseQueryResult<NetworkIngressQueryData, NetworkIngressQueryError> {
  const client = useGramContext();
  return useQuery({
    ...buildNetworkIngressQuery(
      client,
      request,
      security,
      options,
    ),
    ...options,
  });
}

/**
 * getIngress networkIngress
 *
 * @remarks
 * Get the active network ingress for the current organization, when configured.
 */
export function useNetworkIngressSuspense(
  request?: GetNetworkIngressRequest | undefined,
  security?: GetNetworkIngressSecurity | undefined,
  options?: SuspenseQueryHookOptions<
    NetworkIngressQueryData,
    NetworkIngressQueryError
  >,
): UseSuspenseQueryResult<NetworkIngressQueryData, NetworkIngressQueryError> {
  const client = useGramContext();
  return useSuspenseQuery({
    ...buildNetworkIngressQuery(
      client,
      request,
      security,
      options,
    ),
    ...options,
  });
}

export function setNetworkIngressData(
  client: QueryClient,
  queryKeyBase: [parameters: { gramSession?: string | undefined }],
  data: NetworkIngressQueryData,
): NetworkIngressQueryData | undefined {
  const key = queryKeyNetworkIngress(...queryKeyBase);

  return client.setQueryData<NetworkIngressQueryData>(key, data);
}

export function invalidateNetworkIngress(
  client: QueryClient,
  queryKeyBase: TupleToPrefixes<
    [parameters: { gramSession?: string | undefined }]
  >,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: ["@gram/client", "networkIngress", "getIngress", ...queryKeyBase],
  });
}

export function invalidateAllNetworkIngress(
  client: QueryClient,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: ["@gram/client", "networkIngress", "getIngress"],
  });
}
